import VariableChip from '@/components/common/chips/VariableChip';
import { SubroutineId } from '@/types/subroutine';
import { VariableRef } from '@/types/variable';
import { isNullOrUndefined, isNumber } from '@/util/typeGuards';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Tab from '@mui/material/Tab';
import { FC, useState } from 'react';
import PromptListsList from './PromptListsList';
import PromptsList from './PromptsList';

type PromptListPromptPickerDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: (newPrompt: VariableRef | number) => void;
  subroutineId: SubroutineId;
};

const tabPanelSx = {
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  '&[hidden]': { display: 'none' }
};

const PromptListPromptPickerDialog: FC<PromptListPromptPickerDialogProps> = (props) => {
  const [selectedItem, setSelectedItem] = useState<VariableRef | number>();
  const [tabValue, setTabValue] = useState('1');

  const handleClose = () => {
    setSelectedItem(undefined);
    props.onClose();
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const handleSave = (item: VariableRef | number) => {
    props.onSave(item);
    handleClose();
  };

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth='sm'>
      <DialogTitle>Pick Prompt or Prompt List</DialogTitle>
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label='lab API tabs example'>
            <Tab label='Prompts' value='1' />
            <Tab label='Prompt Lists' value='2' />
          </TabList>
        </Box>
        <TabPanel value='1' sx={tabPanelSx}>
          <PromptsList
            onClick={(promptId) => setSelectedItem(promptId)}
            onDoubleClick={(promptId) => handleSave(promptId)}
            value={selectedItem}
          />
        </TabPanel>
        <TabPanel value='2' sx={tabPanelSx}>
          <PromptListsList
            subroutineId={props.subroutineId}
            value={selectedItem}
            onClick={(promptList) => setSelectedItem(promptList)}
            onDoubleClick={(promptList) => handleSave(promptList)}
          />
        </TabPanel>
      </TabContext>
      <Divider />
      <DialogActions>
        {!isNullOrUndefined(selectedItem) && (
          <VariableChip
            label='Chosen: '
            value={selectedItem}
            chipText={isNumber(selectedItem) ? selectedItem : selectedItem.name}
          />
        )}
        <Button onClick={handleClose} color='primary'>
          Cancel
        </Button>
        <Button
          disabled={selectedItem === undefined}
          onClick={() => selectedItem !== undefined && handleSave(selectedItem)}
          color='primary'
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptListPromptPickerDialog;
